import { render, staticRenderFns } from "./LoginPhone.vue?vue&type=template&id=540a3863&scoped=true&"
import script from "./LoginPhone.vue?vue&type=script&lang=js&"
export * from "./LoginPhone.vue?vue&type=script&lang=js&"
import style0 from "./LoginPhone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginPhone.vue?vue&type=style&index=1&id=540a3863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a3863",
  null
  
)

export default component.exports